import * as React from "react";
export const AttachmentIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16.1 18.3" {...props}>
    <path
      className="AttachmentIcon_svg__st0"
      d="M1.8 16.6c-2.4-2.4-2.3-6.2 0-8.6l6.6-6.6c1.8-1.8 4.6-1.8 6.4 0 1.7 1.7 1.7 4.6 0 6.4l-6.6 6.6c-1.1 1.1-2.9 1.1-4 0s-1.1-2.9 0-4l3.9-3.9c.2-.2.6-.2.8 0 .2.2.2.6 0 .8L5 11c-.7.7-.7 1.7 0 2.4s1.7.6 2.4 0L14 6.8c1.3-1.3 1.3-3.4 0-4.7a3.32 3.32 0 00-4.7 0L2.6 8.8c-1.9 1.9-1.9 5 0 6.9s5 1.9 6.9 0l2.8-2.8c.2-.2.6-.2.8 0s.2.6 0 .8l-2.8 2.8c-2.3 2.4-6.2 2.4-8.5.1z"
    />
  </svg>
);
